import "./App.css";
import { Routes, Route } from "react-router-dom";
import ArchiveHeader from "./components/ArchiveHeader";
import Login from "./pages/Login";
import Lecture from "./pages/Lecture";
import LectureList from "./pages/LectureList";
import Upload from "./pages/Upload";
import { AdminRoutes } from "./components/RouteManagers/AdminRoutes";
import { AuthProvider } from "./contexts/AuthContext";
import ArchiveFooter from "./components/ArchiveFooter";
import CompleteSignUp from "./pages/CompleteSignUp";
import { ROUTES } from "./routes";
import { VimeoRoutes } from "./components/RouteManagers/VimeoRoutes";
import VimeoAuthCallback from "./pages/VimeoAuthCallback";
import ForgottenPassword from "./pages/ForgottenPassword";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <AuthProvider>
          <ErrorBoundary fallback={
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <h2>Authentication Error</h2>
              <p>There was a problem with authentication. Please refresh the page.</p>
            </div>
          }>
            <ArchiveHeader />
          </ErrorBoundary>
          
          <ErrorBoundary fallback={
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <h2>Navigation Error</h2>
              <p>There was a problem loading this page. Please try again.</p>
            </div>
          }>
            <Routes>
              <Route path={ROUTES.HOME} element={<LectureList />} />
              <Route path={ROUTES.YEAR} element={<LectureList />} />
              <Route path={ROUTES.LOGIN} element={<Login />} />
              <Route path={ROUTES.COMPLETE_SIGN_UP} element={<CompleteSignUp />} />
              <Route path={ROUTES.FORGOTTEN_PASSWORD} element={<ForgottenPassword />} />
              
              {/* Lecture route accessible to all - authentication handled in component */}
              <Route path={ROUTES.LECTURE} element={<Lecture />} />

              <Route element={<AdminRoutes />}>
                <Route element={<VimeoRoutes />}>
                  <Route path={ROUTES.UPLOAD} element={<Upload />} />
                </Route>

                <Route path={ROUTES.AUTH_VIMEO_CALLBACK} element={<VimeoAuthCallback />} />
              </Route>
            </Routes>
          </ErrorBoundary>
          
          <ArchiveFooter />
        </AuthProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
